import { render, staticRenderFns } from "./sticky-footer.vue?vue&type=template&id=a888c852&scoped=true&"
import script from "./sticky-footer.vue?vue&type=script&lang=js&"
export * from "./sticky-footer.vue?vue&type=script&lang=js&"
import style0 from "./sticky-footer.vue?vue&type=style&index=0&id=a888c852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a888c852",
  null
  
)

export default component.exports